export function telHref(phone) {
  const digits = String(phone || "").replace(/\D/g, "");
  if (!digits) return "";
  if (digits.startsWith("234")) return `tel:+${digits}`;
  if (digits.startsWith("0")) return `tel:+234${digits.slice(1)}`;
  return `tel:+${digits}`;
}

export async function copyPhone(phone) {
  const text = String(phone || "").trim();
  if (!text) return false;
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch (error) {
    return false;
  }
}

export function formatMinutes(seconds) {
  const value = Math.max(1, Math.round(Number(seconds || 0) / 60));
  return `${value} min`;
}

export function formatDistance(meters) {
  const value = Number(meters || 0);
  if (value >= 1000) return `${(value / 1000).toFixed(1)} km`;
  return `${Math.round(value)} m`;
}
